import React, { useMemo } from 'react';
import useSWR from 'swr';
import { useTheme } from '../../../contexts/ThemeContext';
import { fetcher } from '../../../services/fetcher';
import type { CrewStatisticsResponse } from '../../crew/types';
import { StatCounterGrid, type StatCounterItem } from './shared';

function todayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

const CrewPoolCounters: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { colors } = useTheme();
  const today = todayIso();
  const url = `/crew/reports/statistics?withinDays=90&periodFrom=${encodeURIComponent(today)}&periodTo=${encodeURIComponent(today)}`;
  const { data, isLoading } = useSWR<CrewStatisticsResponse>(url, fetcher, { revalidateOnFocus: true });

  const counters: StatCounterItem[] = useMemo(() => {
    const kpis = data?.kpis;
    return [
      {
        key: 'onboard',
        label: 'Onboard',
        value: kpis?.onboardCount ?? 0,
        href: '/crew/statistics/onboard',
        accent: colors.primary,
      },
      {
        key: 'available',
        label: 'Available',
        value: kpis?.availableCount ?? 0,
        href: '/crew/statistics/available',
        accent: colors.accent,
      },
      {
        key: 'not-recommended',
        label: 'Not recommended',
        value: kpis?.notRecommendedCount ?? 0,
        href: '/crew/statistics/not-recommended',
        accent: 'bg-rose-500',
      },
    ];
  }, [colors.accent, colors.primary, data?.kpis]);

  return (
    <StatCounterGrid
      title="Crew · Pool"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/crew"
    />
  );
};

export default CrewPoolCounters;
